import React, { useEffect, useState } from "react";
import _ from "lodash";
import imagesCss from "../../assets/styles/images/images.module.scss";
import css from "../../assets/styles/shared/editor.module.scss";
import EditableText from "../editor/editableText";
import { useNavigate, useParams } from "react-router";
import { Button } from "semantic-ui-react";
import ImagesUploadRequirements from "./specs/ImagesRequirements";
import ImagesEditor from "./specs/imagesEditor";
import { ClipLoader } from "react-spinners";
import { CopyCodeImages } from "./specs/CopyCode";

export default function Images(props) {
  const { id } = useParams();
  const [imageState, setImageState] = useState(defaultState);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      props?.fetch();
    }
  }, [id]);

  useEffect(() => {
    if (id && props?.images?.data?.length > 0) {
      const filterResponse = props?.images?.data?.filter((image) => {
        return Number.parseInt(image?.id) === Number.parseInt(id);
      });

      setImageState({
        id: filterResponse?.[0]?.id,
        data: filterResponse?.[0] ?? defaultState?.data,
      });
    }
  }, [id, props?.images?.data]);

  const handleImageStateChange = (key, value) => {
    setImageState((prev) => {
      const newImageState = _.cloneDeep(prev);
      _.set(newImageState, key, value);
      return newImageState;
    });
  };

  const isImageOptionsInvalid = () => {
    const imageOptions = imageState?.data?.template_data?.image_options;
    if (!Array.isArray(imageOptions) || imageOptions.length === 0) return true;

    return imageOptions.some((option) => {
      return Object.values(option).some((value) => !value);
    });
  };

  const handleSave = () => {
    props?.save(imageState, setLoading, navigate);
  };

  const cancelButton = () => {
    return (
      <Button onClick={() => navigate("/images")} className={css?.cancelButton}>
        Cancel
      </Button>
    );
  };

  const saveButton = () => {
    return (
      <Button
        onClick={handleSave}
        disabled={isImageOptionsInvalid()}
        className={css?.primaryButton}
      >
        {loading ? (
          <div style={{ display: "flex", gap: "3px" }}>
            Save
            <ClipLoader color="#fff" size={15} />
          </div>
        ) : (
          "Save"
        )}
      </Button>
    );
  };

  const renderActionButtons = () => (
    <>
      {cancelButton()}
      {saveButton()}
    </>
  );

  const renderEditableText = () => (
    <div className={css?.editorActions}>
      <EditableText
        name={imageState.data.title}
        onChange={(value) => handleImageStateChange("data.title", value)}
      />
      {renderActionButtons()}
    </div>
  );

  return (
    <div className={imagesCss.imagesEditor}>
      <div className={imagesCss.editorActions}>{renderEditableText()}</div>
      <div className={imagesCss.imagesEditorContainer}>
        <div className={imagesCss.uploadSection}>
          <ImagesEditor
            imageState={imageState}
            setImageState={setImageState}
            slug={imageState?.data?.slug}
          />
          <div className={imagesCss.uploadSectionRight}>
            <ImagesUploadRequirements />
            {imageState?.id !== "new" && (
              <CopyCodeImages slug={imageState?.data?.slug} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const defaultState = {
  id: "new",
  data: {
    title: "New Image",
    template_data: {
      image_options: [],
    },
    subaccount_id: 0,
    archived: false,
  },
};
